import React from 'react'

import { View, YStack } from 'tamagui'

import { Text } from '@newComponents/Text'

import { HomeScreenFeaturesCard } from '../HomeScreenFeaturesCard'

import { MarkerText } from './styles'

export function ConnectedNetworkSection() {
  return (
    <YStack gap='$20' width='100%'>
      <YStack alignItems='center'>
        <View marginTop={150}>
          <MarkerText
            size='$9'
            $gtXs={{ size: '$10' }}
            $gtSm={{ size: '$11' }}
            textAlign='center'
          >
            ONE CONNECTED NETWORK
          </MarkerText>
        </View>
        <Text
          size='$7'
          $gtXs={{ size: '$8' }}
          fontWeight='$6'
          textAlign='center'
        >
          with every feature working together
        </Text>
      </YStack>

      <HomeScreenFeaturesCard />
    </YStack>
  )
}
